// app/javascript/controllers/copy_contact_controller.js
import { Controller } from "@hotwired/stimulus"

// HTML kept as you posted:
// data-controller="copy-contact"
// <input data-copy-contact-target="sameAsMain" ... data-action="change->copy-contact#selectSource">
// <input data-copy-contact-target="sameAsMarketing" ... data-action="change->copy-contact#selectSource">

export default class extends Controller {
    static targets = ["sameAsMain", "sameAsMarketing"]

    connect() {
        this.boundSync = this.syncDirector.bind(this)

        // If one is pre-checked, start syncing immediately
        if (this.sameAsMainTarget?.checked) {
            this.currentSource = "main"
            this.addListeners()
            this.syncDirector()
        } else if (this.sameAsMarketingTarget?.checked) {
            this.currentSource = "marketing"
            this.addListeners()
            this.syncDirector()
        } else {
            this.currentSource = null
        }
    }

    disconnect() {
        this.removeListeners()
    }

    selectSource(e) {
        // enforce single selection
        if (e.target === this.sameAsMainTarget) this.sameAsMarketingTarget.checked = false
        if (e.target === this.sameAsMarketingTarget) this.sameAsMainTarget.checked = false

        // stop any previous sync
        this.removeListeners()

        // start/stop based on current checkbox
        if (this.sameAsMainTarget.checked) {
            this.currentSource = "main"
            this.addListeners()
            this.syncDirector()
        } else if (this.sameAsMarketingTarget.checked) {
            this.currentSource = "marketing"
            this.addListeners()
            this.syncDirector()
        } else {
            this.currentSource = null
            this.clearDirector()
        }
    }

    addListeners() {
        this.sourceIds().forEach(id => {
            const el = document.getElementById(id)
            if (el) el.addEventListener("input", this.boundSync)
        })
    }

    removeListeners() {
        this.sourceIds().forEach(id => {
            const el = document.getElementById(id)
            if (el) el.removeEventListener("input", this.boundSync)
        })
    }

    syncDirector() {
        const [sFirst, sLast, sEmail, sPhone] = this.sourceIds()

        const dFirst = document.getElementById("ceo_first_name")
        const dLast  = document.getElementById("ceo_last_name")
        const dEmail = document.getElementById("ceo_email")

        if (dFirst) dFirst.value = document.getElementById(sFirst)?.value || ""
        if (dLast)  dLast.value  = document.getElementById(sLast)?.value  || ""
        if (dEmail) dEmail.value = document.getElementById(sEmail)?.value || ""

        // Revalidate immediately (native + JustValidate)
        ;["ceo_first_name", "ceo_last_name", "ceo_email"].forEach(id => {
            const el = document.getElementById(id)
            if (!el) return
            el.dispatchEvent(new Event("input",  { bubbles: true }))
            el.dispatchEvent(new Event("change", { bubbles: true }))
        })
    }

    clearDirector() {
        ["ceo_first_name", "ceo_last_name", "ceo_email"].forEach(id => {
            const el = document.getElementById(id)
            if (el) el.value = ""
        })
    }

    sourceIds() {
        // Return the ids (first, last, email, phone) for the active source
        if (this.currentSource === "main") {
            return [
                "main_contact_first_name",
                "main_contact_last_name",
                "main_contact_email",
                "main_contact_phone"
            ]
        }
        if (this.currentSource === "marketing") {
            return [
                "main_lead_first_name",
                "main_lead_last_name",
                "main_lead_email",
                "main_lead_phone"
            ]
        }
        return []
    }
}